<div class="mobile-overlay">
    <h1>Sorry!</h1>
    <p>We've optimized our site for use on a desktop. But don't worry! We have plans in-place to provide a native mobile application to assist you in your deck planning adventures!</p>
    <p>Continuing to the site may not provide the best user experience for your current browser size!</p>
    <button mat-raised-button (click)="dismiss()">Continue</button>
</div>
